import {
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  FormErrorMessage,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

const DeviceValidation = ({ next }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    // call API here
    next(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack spacing={4} align="stretch">
        <FormControl isInvalid={errors.pid}>
          <FormLabel>Device PID</FormLabel>
          <Input {...register('pid', { required: 'PID required' })} />
          <FormErrorMessage>{errors.pid?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.password}>
          <FormLabel>Device Password</FormLabel>
          <Input
            type="password"
            {...register('password', { required: 'Password required' })}
          />
          <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.license}>
          <FormLabel>License Key</FormLabel>
          <Input {...register('license', { required: 'License required' })} />
          <FormErrorMessage>{errors.license?.message}</FormErrorMessage>
        </FormControl>

        <Button type="submit" colorScheme="blue">
          Validate
        </Button>
      </VStack>
    </form>
  );
};

export default DeviceValidation;
